export const truncate = (input: string, len: number) =>
  (input || "").length > len ? `${input.substring(0, len)}...` : input;
